/* 480 FRAMES · interactive gallery. Shows state only – it never sells, opens or closes anything.
   Lot N = frames (N-1)*48+1 … N*48. Lot N+1 is released only when lot N is completely sold out.
   Frame status: available | sold | locked (| closed: safety net only | unknown while loading).
   Status + numbers come from Shopify (shop metafield frame_wall.state + published frame products).
   A labelled simulation exists only in the test theme. Works standalone and inside the OFFALS & BONES section
   (whose preview mounts its content late – a MutationObserver picks the gallery up). */
(function () {
  'use strict';
  var N = 480, LOT = 48, LOTS = 10, COLS = 24, ROWS = 20;
  // 10 shows = 10 lots (owner 28.10.)
  var SHOWS = ['Berlin', 'Prague', 'London', 'Bangkok', 'Lisbon', 'Dresden', 'Paris', 'USA', 'Your town', 'Your town'];
  var pad3 = function (n) { return ('00' + n).slice(-3); };
  var pad2 = function (n) { return ('0' + n).slice(-2); };
  var lotOf = function (n) { return Math.ceil(n / LOT); };
  var range = function (l) { return pad3((l - 1) * LOT + 1) + '–' + pad3(l * LOT); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  function money(v) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(+v); } catch (e) { return v; }
  }
  function spritePos(n) { var i = n - 1; return (i % COLS) / (COLS - 1) * 100 + '% ' + Math.floor(i / COLS) / (ROWS - 1) * 100 + '%'; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  var ARROW = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 4l6 6-6 6"/></svg>';

  // simulation scenarios (test theme only, always labelled on the page)
  function seq(a, b) { var r = []; for (var i = a; i <= b; i++) r.push(i); return r; }
  function rel(lots) { return lots.map(function (l) { return { lot: l, at: new Date(Date.UTC(2026, 10, 13 + (l - 1) * 7, 18)).toISOString(), by: 'sim' }; }); }
  var SCEN = {
    none: { active_lot: null, released: [], sold: [] },
    lot1: { active_lot: 1, released: rel([1]), sold: [] },
    partial: { active_lot: 1, released: rel([1]), sold: [3, 7, 12, 18, 25, 31, 40, 44] },
    soldout: { active_lot: 1, released: rel([1]), sold: seq(1, 48) },
    lot2: { active_lot: 2, released: rel([1, 2]), sold: seq(1, 48).concat([50, 53, 61]) },
    complete: { active_lot: 10, released: rel(seq(1, 10)), sold: seq(1, 480) }
  };
  var LABEL = { available: 'Available', sold: 'Sold', closed: 'Closed', locked: 'Coming soon', unknown: 'Checking…' };
  var STATE_TXT = { available: 'Available', sold: 'Sold', closed: 'Closed · no longer available', locked: 'Coming soon · future release', unknown: 'Checking availability…' };

  function init(root) {
    if (root.__fw) return; root.__fw = true;
    var cfg = JSON.parse(root.querySelector('[data-fw-config]').textContent);
    var preview = root.hasAttribute('data-preview');
    var q = new URLSearchParams(location.search);
    var scen = preview && SCEN[q.get('fw_sim')] ? q.get('fw_sim') : '';
    var sim = cfg.mode !== 'shopify' || !!scen;
    var state = scen ? JSON.parse(JSON.stringify(SCEN[scen])) : (cfg.state || { active_lot: null, released: [] });
    if (sim && preview && !scen) { var saved = store.get('fw-sim-state'); if (saved) try { state = JSON.parse(saved); } catch (e) {} }
    var sold = {}, products = {}, known = sim || !state.active_lot; // nothing released → nothing on sale or sold: 0 / 0 is a fact
    (state.sold || []).forEach(function (n) { sold[n] = true; });
    var log = (state.log || []).slice();
    var $ = function (s) { return root.querySelector(s); };
    if (sim && !$('.fw-simbar')) { var bar = el('p', 'fw-simbar', 'Simulation · test data, not live stock · scenario: '); bar.appendChild(el('span', '', scen || 'settings')); root.insertBefore(bar, root.firstChild.nextSibling); }
    var lbl = $('[data-fw-scenario-label]'); if (lbl) lbl.textContent = scen || 'settings';

    function released() { return (state.released || []).map(function (r) { return r.lot; }); }
    function active() { return state.active_lot || null; }
    function status(n) {
      var l = lotOf(n), a = active();
      if (!a || released().indexOf(l) < 0) return 'locked';
      if (sim) return sold[n] ? 'sold' : (l === a ? 'available' : 'closed');
      var p = products[n];
      if (!p) return known ? 'closed' : 'unknown';
      if (p.tags.indexOf('fw-closed') >= 0) return 'closed';
      return p.available ? (l === a ? 'available' : 'closed') : 'sold';
    }
    function counts(from, to) { var c = { available: 0, sold: 0 }; for (var n = from; n <= to; n++) { var s = status(n); if (c[s] !== undefined) c[s]++; } return c; }
    function lotCounts(l) { return counts((l - 1) * LOT + 1, l * LOT); }

    // ---- 01 the idea: frames fanned out around the current frame; ‹ › (buttons, keys, swipe) flip through all 480
    root.__fwStatus = status; // read by the embedded Living Deck (fw-lab.js)
    var fan = $('[data-fw-fan]'), fanCur = 1, fanCards = [];
    var wrap = function (n) { return ((n - 1) % N + N) % N + 1; };
    function layoutFan() {
      if (!fan || !fan.offsetHeight) return;
      var H = fan.offsetHeight - 34, mainW = H * 4 / 4.93, step = Math.max(10, H * .075);
      fanCards.forEach(function (i) {
        var k = +i.dataset.k, side = +i.dataset.side, h = 84 - k * 3.2, w = H * h / 100 * 4 / 4.75;
        i.style.setProperty('--h', h); i.style.setProperty('--x', side * (mainW / 2 - w / 2 + 8 + k * step) + 'px');
      });
    }
    function sheetPos(n) { var k = (n - 1) % LOT, kk = k % 24; return { url: cfg.sheets[(lotOf(n) - 1) * 2 + (k >= 24 ? 1 : 0)], pos: (kk % 6) / 5 * 100 + '% ' + Math.floor(kk / 6) / 3 * 100 + '%' }; }
    function setFan(n, dir) {
      fanCur = wrap(n);
      fanCards.forEach(function (i) { i.style.setProperty('--p', spritePos(wrap(fanCur + (+i.dataset.side) * (+i.dataset.k) * 6))); });
      var main = $('[data-fw-fan-main]'), im = main.querySelector('img'), bg = $('[data-fw-fan-img]');
      if (fanCur === 1) { im.hidden = false; bg.hidden = true; }
      else { var sp = sheetPos(fanCur); bg.style.backgroundImage = 'url(' + sp.url + ')'; bg.style.backgroundPosition = sp.pos; bg.hidden = false; im.hidden = true; }
      main.setAttribute('aria-label', 'Open frame ' + fanCur);
      $('[data-fw-fan-count]').textContent = 'Frame #' + fanCur + ' / 480';
      if (dir && !reduced) { fan.classList.remove('is-flip'); void fan.offsetWidth; fan.classList.add('is-flip'); }
    }
    if (fan) {
      for (var k = 1; k <= 9; k++) [-1, 1].forEach(function (side) {
        var i = el('i'); i.dataset.k = k; i.dataset.side = side; i.style.setProperty('--z', 20 - k); fan.appendChild(i); fanCards.push(i);
      });
      setFan(1); layoutFan();
      if ('ResizeObserver' in window) new ResizeObserver(layoutFan).observe(fan); else window.addEventListener('resize', layoutFan);
      root.querySelectorAll('[data-fw-fan-step]').forEach(function (b) { b.addEventListener('click', function () { setFan(fanCur + (+b.dataset.fwFanStep), +b.dataset.fwFanStep); }); });
      $('[data-fw-fan-main]').addEventListener('click', function () { if (!fanMoved) openX(fanCur); });
      fan.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); setFan(fanCur + (e.key === 'ArrowRight' ? 1 : -1), 1); } });
      var fx = null, fanMoved = false;
      fan.addEventListener('pointerdown', function (e) { fx = e.clientX; fanMoved = false; });
      fan.addEventListener('pointerup', function (e) { if (fx === null) return; var dx = e.clientX - fx; fx = null; if (Math.abs(dx) > 40) { fanMoved = true; setFan(fanCur + (dx < 0 ? 1 : -1), 1); } });
    }

    // ---- 02 the gallery
    var wall = $('[data-fw-wall]'), list = $('[data-fw-list]'), tip = $('[data-fw-tip]'), empty = $('[data-fw-empty]'), cells = [], rows = [];
    var frag = document.createDocumentFragment(), lfrag = document.createDocumentFragment();
    for (var n = 1; n <= N; n++) {
      var b = el('button', 'fw-cell'); b.type = 'button'; b.dataset.n = n; b.style.setProperty('--p', spritePos(n));
      frag.appendChild(b); cells.push(b);
      var li = el('li'); li.dataset.n = n; li.tabIndex = 0; var th = el('i'); th.style.setProperty('--p', spritePos(n));
      li.appendChild(th); li.appendChild(el('b', '', 'Frame #' + pad3(n))); li.appendChild(el('span', '', 'Lot ' + pad2(lotOf(n)) + ' · ' + range(lotOf(n))));
      li.appendChild(el('span')); li.appendChild(el('em')); lfrag.appendChild(li); rows.push(li);
    }
    wall.appendChild(frag); list.appendChild(lfrag);
    function paint() {
      cells.forEach(function (c, i) {
        var n = i + 1, s = status(n), p = products[n];
        c.dataset.s = s; c.setAttribute('aria-label', 'Frame ' + pad3(n) + ' of 480, ' + LABEL[s]);
        var r = rows[i]; r.dataset.s = s;
        r.children[3].textContent = p && p.price && s === 'available' ? money(p.price) : '';
        r.children[4].textContent = LABEL[s];
      });
      applyFilter(); renderCounts(); renderAdmin();
    }
    function showTip(c) {
      var n = +c.dataset.n, s = status(n), w = tip.parentNode.getBoundingClientRect(), r = c.getBoundingClientRect();
      tip.innerHTML = ''; tip.appendChild(document.createTextNode('Frame #' + n));
      var st = el('small'); st.appendChild(el('i', 'fw-dot is-' + s)); st.appendChild(document.createTextNode(LABEL[s])); tip.appendChild(st);
      tip.hidden = false;
      var grow = r.width * 1.2, x = r.right - w.left + grow + 8;
      if (x + tip.offsetWidth > w.width - 4) x = r.left - w.left - grow - 8 - tip.offsetWidth;
      tip.style.left = Math.max(4, x) + 'px'; tip.style.top = (r.top - w.top + r.height * .9) + 'px';
    }
    var hot = null;
    function setHot(c) {
      if (hot) hot.classList.remove('is-hot');
      hot = c; wall.classList.toggle('is-hover', !!c);
      if (c) { c.classList.add('is-hot'); showTip(c); } else tip.hidden = true;
    }
    wall.addEventListener('pointerover', function (e) { var c = e.target.closest('.fw-cell'); if (c && e.pointerType === 'mouse') setHot(c); });
    wall.addEventListener('pointerleave', function () { setHot(null); });
    wall.addEventListener('focusin', function (e) { var c = e.target.closest('.fw-cell'); if (c) setHot(c); });
    wall.addEventListener('focusout', function () { setHot(null); });
    wall.addEventListener('click', function (e) { var c = e.target.closest('.fw-cell'); if (c) openX(+c.dataset.n); });
    wall.addEventListener('keydown', function (e) {
      var c = e.target.closest('.fw-cell'); if (!c) return;
      var vis = cells.filter(function (x) { return !x.hidden; }), i = vis.indexOf(c), cols = getComputedStyle(wall).gridTemplateColumns.split(' ').length, t = -1;
      if (e.key === 'ArrowRight') t = i + 1; else if (e.key === 'ArrowLeft') t = i - 1; else if (e.key === 'ArrowDown') t = i + cols; else if (e.key === 'ArrowUp') t = i - cols;
      if (t >= 0 && t < vis.length) { e.preventDefault(); vis[t].focus(); }
    });
    list.addEventListener('click', function (e) { var r = e.target.closest('li'); if (r) openX(+r.dataset.n); });
    list.addEventListener('keydown', function (e) { var r = e.target.closest('li'); if (r && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openX(+r.dataset.n); } });

    // filters (really filter: non-matching frames are removed from the grid / list)
    // the wall shows ONE lot of 48 at a time (owner 28.10.: max. 48 per view, max. 6 columns); default = the open lot
    var filter = 'all', chips = root.querySelectorAll('[data-fw-filter]'), lotSel = active() || 1, lotsEl = $('[data-fw-lots]');
    if (lotsEl) {
      for (var l = 1; l <= LOTS; l++) { var lb = el('button', 'fw-lot'); lb.type = 'button'; lb.dataset.fwLot = l; lb.innerHTML = '<b>' + pad2(l) + '</b><span>' + SHOWS[l - 1] + '</span><small></small>'; lotsEl.appendChild(lb); }
      lotsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-fw-lot]'); if (b) { lotSel = +b.dataset.fwLot; applyFilter(); } });
    }
    function paintLots() {
      if (!lotsEl) return; var a = active();
      [].forEach.call(lotsEl.children, function (b) { var l = +b.dataset.fwLot; b.setAttribute('aria-pressed', l === lotSel ? 'true' : 'false'); b.querySelector('small').textContent = !a || l > a ? 'Coming' : l === a ? 'On sale' : 'Released'; b.dataset.st = !a || l > a ? 'locked' : l === a ? 'open' : 'past'; });
    }
    function applyFilter() {
      var shown = 0;
      cells.forEach(function (c, i) { var on = lotOf(i + 1) === lotSel && (filter === 'all' || c.dataset.s === filter); c.hidden = !on; rows[i].hidden = !on; if (on) shown++; });
      chips.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.fwFilter === filter ? 'true' : 'false'); });
      empty.hidden = shown > 0; paintLots();
    }
    chips.forEach(function (b) { b.addEventListener('click', function () { filter = b.dataset.fwFilter; applyFilter(); }); });

    // search by frame number (#217 or 217)
    var search = $('[data-fw-search]'), found = null;
    function findNumber(open) {
      var v = parseInt(String(search.value).replace(/\D/g, ''), 10);
      if (found) found.classList.remove('is-found'); found = null;
      if (!(v >= 1 && v <= N)) return;
      if (cells[v - 1].hidden) { filter = 'all'; lotSel = lotOf(v); applyFilter(); }
      found = view === 'grid' ? cells[v - 1] : rows[v - 1]; found.classList.add('is-found');
      found.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      if (open) openX(v);
    }
    search.addEventListener('input', function () { findNumber(false); });
    search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); findNumber(true); } });

    // grid / list view
    var view = 'grid';
    root.querySelectorAll('[data-fw-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        view = b.dataset.fwView; wall.hidden = view !== 'grid'; list.hidden = view !== 'list';
        root.querySelectorAll('[data-fw-view]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });

    // thumbnail size (− slider +)
    var zoomIn = $('[data-fw-zoom]');
    // columns snap to divisors of 48, so a row is always one lot (48) or exactly half / third / quarter of one – on any screen width
    function fitCols() { var W = (wall.clientWidth || wall.parentNode.clientWidth || innerWidth); wall.style.setProperty('--fw-cols', W >= 720 ? 16 : W >= 460 ? 12 : 8); } // one lot of 48: 16 × 3 on desktop (owner 28.10.), 12 × 4 / 8 × 6 on small screens
    function setTile(v) { v = Math.max(0, Math.min(100, v)); zoomIn.value = v; wall.style.setProperty('--fw-tile', Math.round(30 + v * .8) + 'px'); fitCols(); }
    if ('ResizeObserver' in window) new ResizeObserver(fitCols).observe(wall.parentNode); else window.addEventListener('resize', fitCols);
    zoomIn.addEventListener('input', function () { setTile(+zoomIn.value); });
    root.querySelectorAll('[data-fw-size]').forEach(function (b) { b.addEventListener('click', function () { setTile(+zoomIn.value + (b.dataset.fwSize === '+' ? 10 : -10)); }); });
    setTile(window.innerWidth < 750 ? 5 : +zoomIn.value); // denser on phones (≈ 10 per row)

    function renderCounts() {
      var c = counts(1, N), put = function (k, v) { $('[data-fw-c="' + k + '"]').textContent = v; };
      put('available', known ? c.available : '–'); put('sold', known ? c.sold : '–');
    }

    // ---- 03 the frame
    var dlg = $('[data-fw-explorer]'), stage = $('[data-fw-x-stage]'), img = $('[data-fw-x-img]');
    var near = $('[data-fw-x-near]'), zbox = $('[data-fw-x-zoom]'), zimg = $('[data-fw-x-zoomimg]'), cur = 1, z = 1, tx = 0, ty = 0;
    function applyT() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + z + ')'; stage.classList.toggle('is-zoomed', z > 1); }
    function zoomAt(f, cx, cy) {
      var nz = Math.min(6, Math.max(1, z * f)), r = img.getBoundingClientRect(), ox = (cx - r.left) / z, oy = (cy - r.top) / z;
      tx += (z - nz) * ox; ty += (z - nz) * oy; z = nz; if (z === 1) { tx = 0; ty = 0; }
      applyT();
    }
    function loupe(fx, fy) {
      if (!zbox.offsetWidth) return;
      zimg.style.transform = 'translate(' + (-(zimg.offsetWidth - zbox.offsetWidth) * fx) + 'px,' + (-(zimg.offsetHeight - zbox.offsetHeight) * fy) + 'px)';
    }
    function spec(rows2) {
      var d = $('[data-fw-x-spec]'); d.innerHTML = '';
      rows2.forEach(function (r) { if (!r[1]) return; d.appendChild(el('dt', '', r[0])); d.appendChild(el('dd', '', r[1])); });
    }
    var findMode = false, lastFocus = null;
    function show(n) {
      cur = Math.min(N, Math.max(1, n)); z = 1; tx = ty = 0; applyT();
      var l = lotOf(cur), k = (cur - 1) % LOT, sheet = cfg.sheets[(l - 1) * 2 + (k >= 24 ? 1 : 0)], kk = k % 24, s = status(cur), p = products[cur];
      var pos = (kk % 6) / 5 * 100 + '% ' + Math.floor(kk / 6) / 3 * 100 + '%';
      img.style.backgroundImage = zimg.style.backgroundImage = 'url(' + sheet + ')';
      img.style.backgroundPosition = zimg.style.backgroundPosition = pos;
      img.setAttribute('aria-label', 'Frame ' + cur + ' of the animation');
      loupe(.55, .45);
      $('[data-fw-x-title]').textContent = 'Frame #' + cur;
      $('[data-fw-x-cap]').textContent = 'Frame #' + cur + ' / 480';
      var stEl = $('[data-fw-x-state]'); stEl.textContent = ''; stEl.className = 'fw-x__state is-' + s;
      stEl.appendChild(el('i', 'fw-dot is-' + s)); stEl.appendChild(document.createTextNode(STATE_TXT[s]));
      var act = $('[data-fw-x-actions]'); act.innerHTML = '';
      if (s === 'available') {
        var label = 'Add to cart — one of one';
        if (!sim && p && p.variant) {
          var f = el('form'); f.method = 'post'; f.action = cfg.cartAdd;
          var idIn = el('input'); idIn.type = 'hidden'; idIn.name = 'id'; idIn.value = p.variant;
          var qIn = el('input'); qIn.type = 'hidden'; qIn.name = 'quantity'; qIn.value = '1';
          var sb = el('button', 'fw-btn fw-btn--solid'); sb.type = 'submit'; sb.innerHTML = '<span></span>' + ARROW; sb.firstChild.textContent = label;
          f.appendChild(idIn); f.appendChild(qIn); f.appendChild(sb); act.appendChild(f);
        } else { var x = el('button', 'fw-btn fw-btn--solid'); x.type = 'button'; x.disabled = true; x.title = 'Simulation – no product linked'; x.innerHTML = '<span></span>' + ARROW; x.firstChild.textContent = label; act.appendChild(x); }
      }
      var lockNote = l === (active() || 0) + 1 ? (l === 1 ? ' · in the first 48' : ' · released when Lot ' + pad2(l - 1) + ' is sold out') : ' · lot ' + pad2(l) + ' (' + range(l) + ')';
      spec([['Frame number', cur + ' / 480'], ['Availability', LABEL[s] + (s === 'locked' ? lockNote : '')],
        ['Edition', 'One of one'], ['Part of', 'The Complete Animation'], ['Medium', cfg.medium], ['Artist', 'mcbess'],
        ['Price', p && p.price ? money(p.price) : '']]);
      near.innerHTML = '';
      [cur - 1, cur, cur + 1].forEach(function (i) {
        if (i < 1 || i > N) { near.appendChild(el('span')); return; }
        var nb = el('button'); nb.type = 'button'; nb.dataset.n = i; var t = el('i'); t.style.setProperty('--p', spritePos(i)); nb.appendChild(t);
        nb.appendChild(el('span', '', '#' + i)); nb.setAttribute('aria-label', 'Frame ' + i);
        if (i === cur) nb.setAttribute('aria-current', 'true'); near.appendChild(nb);
      });
      if (dlg.open) history.replaceState(null, '', '#frame-' + pad3(cur));
    }
    function openX(n) { lastFocus = document.activeElement; setHot(null); if (!dlg.open) dlg.showModal(); show(n); }
    function closeX() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { history.replaceState(null, '', location.pathname + location.search); if (lastFocus && lastFocus.focus) lastFocus.focus(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { closeX(); return; }
      var nb = e.target.closest('[data-fw-x-near] button[data-n]'); if (nb) { show(+nb.dataset.n); return; }
      var b = e.target.closest('[data-fw-x]'); if (!b) return;
      var a = b.getAttribute('data-fw-x');
      if (a === 'close') closeX(); else if (a === 'prev') show(cur - 1); else if (a === 'next') show(cur + 1);
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1); }
      else if (e.key === '+' || e.key === '=') { var r = stage.getBoundingClientRect(); zoomAt(1.5, r.left + r.width / 2, r.top + r.height / 2); }
      else if (e.key === '-') { var r2 = stage.getBoundingClientRect(); zoomAt(1 / 1.5, r2.left + r2.width / 2, r2.top + r2.height / 2); }
    });
    stage.addEventListener('wheel', function (e) { e.preventDefault(); zoomAt(e.deltaY < 0 ? 1.15 : 1 / 1.15, e.clientX, e.clientY); }, { passive: false });
    var pts = {}, start = null, pinch = 0, moved = false;
    stage.addEventListener('pointerdown', function (e) { stage.setPointerCapture(e.pointerId); pts[e.pointerId] = e; start = { x: e.clientX, y: e.clientY, tx: tx, ty: ty }; moved = false; });
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect(); loupe(Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)));
      if (!pts[e.pointerId]) return; pts[e.pointerId] = e;
      if (start && Math.hypot(e.clientX - start.x, e.clientY - start.y) > 6) moved = true;
      var ids = Object.keys(pts);
      if (ids.length === 2) { var a = pts[ids[0]], b = pts[ids[1]], d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); if (pinch) zoomAt(d / pinch, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2); pinch = d; return; }
      if (z > 1 && start) { tx = start.tx + e.clientX - start.x; ty = start.ty + e.clientY - start.y; applyT(); }
    });
    function up(e) {
      if (start && Object.keys(pts).length === 1) {
        var dx = e.clientX - start.x;
        if (z === 1 && Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
        else if (!moved && e.type === 'pointerup') { if (z > 1) { z = 1; tx = ty = 0; applyT(); } else zoomAt(2.5, e.clientX, e.clientY); }
      }
      delete pts[e.pointerId]; pinch = 0; if (!Object.keys(pts).length) start = null;
    }
    stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);

    // ---- "the next 48 have arrived" (visual only – the release itself happens server-side)
    var relEl = $('[data-fw-release]');
    function lastRelease() { var r = (state.released || []).slice(-1)[0]; return r ? r.at : ''; }
    function showRelease(lot) {
      if (reduced || !lot) return;
      var g = $('[data-fw-release-grid]'); g.innerHTML = ''; g.style.setProperty('--fw-sprite', 'url(' + cfg.wall + ')');
      for (var n = (lot - 1) * LOT + 1, k = 0; n <= lot * LOT; n++, k++) { var i = el('i'); i.style.setProperty('--p', spritePos(n)); i.style.setProperty('--k', k); g.appendChild(i); }
      $('[data-fw-release-lot]').textContent = 'Lot ' + pad2(lot) + ' / 10 · Frames ' + range(lot);
      relEl.hidden = false; $('[data-fw-release-go]').focus();
    }
    function hideRelease() { relEl.hidden = true; }
    $('[data-fw-release-go]').addEventListener('click', function () { hideRelease(); filter = 'available'; lotSel = active() || lotSel; applyFilter(); wall.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); });
    relEl.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideRelease(); });
    relEl.addEventListener('click', function (e) { if (e.target === relEl) hideRelease(); });
    function checkRelease() {
      var lr = lastRelease(), seen = store.get('fw-seen-release');
      if (lr && seen && seen < lr) showRelease(active());
      if (lr) store.set('fw-seen-release', lr);
    }

    // ---- admin panel (theme preview only)
    var admin = $('[data-fw-admin]');
    function renderAdmin() {
      if (!admin) return;
      var a = active(), c = a ? lotCounts(a) : null, nx = (a || 0) + 1;
      var put = function (k, v) { admin.querySelector('[data-fw-a="' + k + '"]').textContent = v; };
      put('active', a ? 'Lot ' + pad2(a) + ' (' + range(a) + ')' : 'none');
      put('avail', c && known ? c.available : '—'); put('sold', c && known ? c.sold : '—');
      put('next', nx <= LOTS ? 'Lot ' + pad2(nx) + ' (' + range(nx) + ')' : 'edition complete');
      put('last', lastRelease() ? new Date(lastRelease()).toLocaleString() : '—');
      var rb = admin.querySelector('[data-fw-a-release]'); rb.textContent = nx <= LOTS ? 'Release lot ' + pad2(nx) : 'All lots released'; rb.disabled = nx > LOTS;
      rb.title = a && known && c.available > 0 ? 'Only possible when Lot ' + pad2(a) + ' is sold out' : '';
      if (sim) { var lg = admin.querySelector('[data-fw-a-log]'); lg.innerHTML = ''; log.slice().reverse().forEach(function (e) { lg.appendChild(el('li', '', 'Lot ' + pad2(e.lot) + ' · ' + e.at + ' · ' + e.by + ' · ' + e.prev + ' → ' + e.next + ' · ' + e.result)); }); }
    }
    if (admin) {
      admin.querySelector('[data-fw-a-preview]').addEventListener('click', function () { var nx = (active() || 0) + 1; if (nx <= LOTS) showRelease(nx); });
      admin.querySelector('[data-fw-a-release]').addEventListener('click', function () {
        var a = active(), nx = (a || 0) + 1, note = admin.querySelector('[data-fw-a-note]');
        if (nx > LOTS) return;
        if (a && lotCounts(a).available > 0) { note.textContent = 'Lot ' + pad2(a) + ' is not sold out yet (' + lotCounts(a).available + ' of 48 still available). Lot ' + pad2(nx) + ' can only be released when Lot ' + pad2(a) + ' is completely sold out.'; return; }
        var msg = 'You are about to activate Lot ' + pad2(nx) + ', Frames ' + range(nx) + '.' + (a ? ' Lot ' + pad2(a) + ' is sold out (48/48).' : '') + ' Continue?';
        if (!sim) { note.textContent = 'Live releases run only through the authenticated admin tool: ' + cfg.releaseCommand.replace('{lot}', nx) + ' – this page cannot change the shop.'; return; }
        if (!window.confirm(msg)) return;
        var prev = a ? 'Lot ' + pad2(a) + ' open' : 'none';
        state.released = (state.released || []).concat([{ lot: nx, at: new Date().toISOString(), by: 'staff (simulation)' }]);
        state.active_lot = nx; state.sold = Object.keys(sold).map(Number);
        log.push({ lot: nx, at: new Date().toISOString(), by: 'staff (simulation)', prev: prev, next: 'Lot ' + pad2(nx) + ' open', result: 'success' });
        state.log = log; if (!scen) store.set('fw-sim-state', JSON.stringify(state));
        note.textContent = 'Simulated release done (only in this browser, nothing in Shopify changed).';
        paint(); showRelease(nx);
      });
      var sc = admin.querySelector('[data-fw-scenario]');
      sc.value = scen;
      sc.addEventListener('change', function () { store.del('fw-sim-state'); var u = new URL(location.href); if (sc.value) u.searchParams.set('fw_sim', sc.value); else u.searchParams.delete('fw_sim'); location.href = u.toString(); });
    }

    // ---- Shopify data: published frame products only (locked frames are unpublished and never listed)
    function loadProducts(page) {
      return fetch('/collections/' + encodeURIComponent(cfg.collection) + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) {
          (d.products || []).forEach(function (p) {
            var m = p.handle.indexOf(cfg.productPrefix) === 0 ? parseInt(p.handle.slice(cfg.productPrefix.length), 10) : NaN;
            if (!(m >= 1 && m <= N)) return;
            var v = p.variants && p.variants[0];
            products[m] = { id: p.id, tags: p.tags || [], available: !!(v && v.available), price: v ? v.price : '', variant: v ? v.id : null };
          });
          if ((d.products || []).length === 250 && page < 3) return loadProducts(page + 1);
        });
    }
    function refresh() { return loadProducts(1).then(function () { known = true; paint(); if (dlg.open) show(cur); }).catch(function () { paint(); }); }
    paint();
    if (!sim && active()) {
      refresh();
      // stock changes while the page is open: re-check when the tab comes back and every 60 s while visible
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
      setInterval(function () { if (!document.hidden) refresh(); }, 60000);
    }
    var m = location.hash.match(/^#frame-(\d{1,3})$/) || [null, q.get('frame')];
    if (m[1] && +m[1] >= 1 && +m[1] <= N) openX(+m[1]);
    window.addEventListener('hashchange', function () { var h = location.hash.match(/^#frame-(\d{1,3})$/); if (h && +h[1] >= 1 && +h[1] <= N) openX(+h[1]); });
    checkRelease();
  }

  function scan() { document.querySelectorAll('[data-fw-root]').forEach(init); }
  scan();
  if ('MutationObserver' in window) new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { scan(); return; } }).observe(document.documentElement, { childList: true, subtree: true });
})();
